import React, { useState, useEffect } from 'react';
import './GeneralSettings.scss';

const GeneralSettings = () => {
  const [isPrompt, setIsPrompt] = useState(false);
  const [isPost, setIsPost] = useState(false);
  const [apiKey, setApiKey] = useState('');
  const [buttonText, setButtonText] = useState('Opslaan');
  const [isSaved, setIsSaved] = useState(true); // Track if changes are saved

  useEffect(() => {
    // Retrieve the API key and toggle status from localStorage when the component mounts
    const savedApiKey = localStorage.getItem('openai_api_key');
    if (savedApiKey) {
      setApiKey(savedApiKey);
    }
    const savedIsPrompt = localStorage.getItem('is_prompt');
    if (savedIsPrompt) {
      setIsPrompt(savedIsPrompt === 'true');
    }

    const savedIsPost = localStorage.getItem('is_post');
    if (savedIsPost) {
      setIsPost(savedIsPost === 'true');
    }

    // Add beforeunload event listener
    const handleBeforeUnload = (event) => {
      if (!isSaved) {
        const message = 'U hebt onopgeslagen wijzigingen. Weet u zeker dat u de pagina wilt verlaten?';
        event.returnValue = message; // Standard for most browsers
        return message; // For some browsers
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isSaved]);

  const handleToggle = () => {
    const newIsPrompt = !isPrompt;
    setIsPrompt(newIsPrompt);
    localStorage.setItem('is_prompt', newIsPrompt);
    setIsSaved(false); // Mark changes as not saved
  };

  const handlePostToggle = () => {
    const newIsPost = !isPost;
    setIsPost(newIsPost);
    localStorage.setItem('is_post', newIsPost);
    setIsSaved(false);
  }

  const handleApiKeyChange = (event) => {
    setApiKey(event.target.value);
    setIsSaved(false); // Mark changes as not saved
  };

  const handleSave = () => {
    // Save the API key to localStorage
    localStorage.setItem('openai_api_key', apiKey);
    // Change the button text to "Opgeslagen" and revert after 3 seconds
    setButtonText('Opgeslagen');
    setIsSaved(true); // Mark changes as saved
    setTimeout(() => {
      setButtonText('Opslaan');
    }, 3000);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSave();
    }
  };

  return (
    <div className="banner-settings-wrapper">
      <h1>Algemene instellingen</h1>
      <div className="banner-settings-switch">
        <div className="banner-settings-inner-content">
          <div className="banner-settings-inner-content-details_input">
            <h5>Prompt or text</h5>
            <p>
              Kies hier om de prompt of een text te laten genereren.<br/>
              Voor het genereren van een prompt moet er een API Key zijn ingevoerd.
            </p>
          </div>
          <div className="banner-settings-inner-content-toggle">
            <label className="switch">
              <input
                type="checkbox"
                checked={isPrompt}
                onChange={handleToggle}
              />
              <span className="slider round">
                <span className="slider-text">{isPrompt ? 'Text' : 'Prompt'}</span>
              </span>
            </label>
          </div>
        </div>
      </div>
      <div className="banner-settings-switch">
        <div className="banner-settings-inner-content">
          <div className="banner-settings-inner-content-details_input">
            <h5>Generate in post</h5>
            <p>
              Bepaal of het mogelijk moet zijn om een tekst te generen vanuit de Post Editor.<br/>
              Voor het genereren van een prompt moet er een API Key zijn ingevoerd.
            </p>
          </div>
          <div className="banner-settings-inner-content-toggle">
          <label className="switch">
            <input
                type="checkbox"
                checked={isPost}
                onChange={handlePostToggle}
              />
              <span className="slider round">
                <span className="slider-text">{isPost ? 'Aan' : 'Uit'}</span>
              </span>
            </label>
          </div>
        </div>
      </div>
      <div className="banner-settings-switch">
        <div className="banner-settings-inner-content">
          <div className="banner-settings-inner-content-details_input">
            <h5>OpenAI API Key</h5>
            <p>
              Voer hier de API Key in die je krijgt vanuit de portal van OpenAI.<br/>
              Klik <a href="https://platform.openai.com/docs/overview" target="_blank">hier</a> om een API Key aan te vragen.
            </p>
          </div>
          <div className="banner-settings-inner-content-toggle">
            <input
              type="text"
              id="apiKey"
              value={apiKey}
              onChange={handleApiKeyChange}
              onKeyPress={handleKeyPress}
            />
          </div>
        </div>
      </div>
      <div className="save-button-div">
        <button className="save-button" onClick={handleSave}>{buttonText}</button>
      </div>
    </div>
  );
};

export default GeneralSettings;
